module.exports = __webpack_public_path__ + "img/wallet-svgrepo-com.e21bd8c7.svg";